import React from "react";
import "./header.scss";
import appConfig from "../../environment/environments";
import NotificationsIcon from "@material-ui/icons/Notifications";
import UnitCalculator from "./unitcalculator/unitCalculator";
import ProfileDropdown from "./profileDropdown";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";
import { constants } from "../../constants/constants";

const Header = ({ permission, intl }) => {
  return (
    <>
      <header>
        <div className="container">
          <div className="header-wrapper">
            <div className="brand-logo">
              <a
                className="drawing-manager-logo"
                href={appConfig.loginConfig.uiUrl}
              >
                Drawing Manager
              </a>
            </div>
            <div className="user-role">
              <span className="role-text">{injectIntlTranslation(intl, "adminLabel" , constants.adminLabel)}</span>
            </div>
            <div className="header-right-content">
              <nav className="dropdown-right">
                <UnitCalculator />
                <Tooltip>
                  <IconButton
                    disabled={true}
                    role="button"
                    className="dropdown-toggler"
                    onClick={(e) => {}}
                    style={{ padding: 0, color: "#fff" }}
                  >
                    <NotificationsIcon />
                  </IconButton>
                </Tooltip>
                {/* <NotificationsList/> */}
                <ProfileDropdown permission={permission} />
              </nav>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default injectIntl(Header);
